module.exports = __webpack_public_path__ + "img/forklift-truck-icon.4f82cabe.svg";